import styled from 'styled-components'
import { StickyCartProps } from './StickyCart'

const VIEWPORT = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
}

type StickyCartWrapperProp = {
  stickyCartInMobile?
  stickyCartInDesktop?
}

export const StickyCartWrapper = styled.div<StickyCartWrapperProp>`
  display: ${(props) => (props.stickyCartInMobile ? 'block' : 'none')};
  padding-bottom: 32px;
  @media only screen and (min-width: ${VIEWPORT.lg}) {
    display: ${(props) => (props.stickyCartInDesktop ? 'block' : 'none')};
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: relative;
  }
`

export const StickyCartBlock = styled.div`
  padding: 12px 16px;
  @media only screen and (min-width: ${VIEWPORT.lg}) {
    padding-top: 24px;
    padding-left: 24px;
    padding-bottom: 0px;
    position: sticky;
    top: 0;
    margin: 0 auto;
    max-width: 400px;
  }
`

type MobileStickyCartProp = {
  stickyCartInMobile?
}

export const MobileStickyCart = styled.div<MobileStickyCartProp>`
  display: ${(props) => (props.stickyCartInMobile ? 'block' : 'none')};
`

type StickyNavProp = {
  visible
}

export const StickyNav = styled.div<StickyNavProp>`
  width: 100%;
  background: #fff;
  line-height: 24px;
  font-size: 1rem;
  padding: 16px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 30;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  display: ${(props) => (props.visible ? 'block' : 'none')};
  @media only screen and (min-width: ${VIEWPORT.sm}) {
    display: ${(props) => (props.visible ? 'flex' : 'none')};
    height: 80px;
    align-items: center;
    justify-content: space-between;
  }
  @media only screen and (min-width: ${VIEWPORT.md}) {
    justify-content: unset;
  }
`

export const XlNav = styled.div`
  margin: 0 auto;
  width: 100%;
  @media only screen and (min-width: ${VIEWPORT.sm}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  @media only screen and (min-width: ${VIEWPORT.xl}) {
    width: 1168px;
  }
`

export const StickyNavInfoContainer = styled.div`
  display: none;
  @media only screen and (min-width: ${VIEWPORT.sm}) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
  }
  @media only screen and (min-width: ${VIEWPORT.md}) {
    justify-content: space-between;
    width: 100%;
    padding-right: 16px;
  }
  @media only screen and (min-width: ${VIEWPORT.xl}) {
    justify-content: space-between;
    width: 100%;
    padding-right: 16px;
    max-width: 1200px;
  }
`

export const StickyNavInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  .navRibbon {
    height: 40px;
  }
  @media only screen and (min-width: ${VIEWPORT.sm}) {
    display: none;
  }
  @media only screen and (min-width: ${VIEWPORT.md}) {
    display: flex;
    p {
      display: none;
    }
  }
  @media only screen and (min-width: ${VIEWPORT.lg}) {
    p {
      display: block;
    }
  }
`

export const StickyNavRibbon = styled.div`
  background-color: #613889;
  padding: 5px 16px 0;
  display: inline-block;
  max-width: 100%;
  height: 2.188rem;
  font-weight: 500;
  color: #fff;
  font-size: 1rem;
  line-height: 2rem;
  border-radius: 4px;
  font-family: 'HNforTELUSSA400normal';
`

export const CartPrice = styled.div`
  display: inline-block;
  width: 100%;
`

export const ProductTitle = styled.p`
  padding-left: 16px;
  font-size: 1rem;
  max-width: 100%;
  margin: 0px;
`

export const ProductContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

type ProductDescriptionProp = {
  color?
}

export const ProductDescription = styled.div<ProductDescriptionProp>`
  display: flex;
  font-size: 1rem;
  font-family: 'HNforTELUSSA400normal';
  color: ${(props) => (props.color === 'primary' ? '#2C2E30' : '#4b286d')};
  margin-bottom: 18px;
  align-items: flex-start;
  padding-right: 16px;
  @media only screen and (min-width: ${VIEWPORT.lg}) {
    font-family: 'HNforTELUSSA500normal';
  }
`

export const ProductPrice = styled.p`
  color: #2a2c2e;
  font-size: 1rem;
  font-family: 'HNforTELUSSA300normal';
  margin-top: 0;
`

type LinkButtonProp = {
  alignStickySecondaryButtonText?: StickyCartProps['alignStickySecondaryButtonText']
}

export const LinkButton = styled.div<LinkButtonProp>`
  text-align: ${(props) => (props.alignStickySecondaryButtonText ? props.alignStickySecondaryButtonText : 'left')};
  padding-top: 24px;
`

export const PriceContainer = styled.div`
  padding-bottom: 1rem;
`

export const RibbonContainer = styled.div`
  padding-bottom: 8px;
`

export const IconPosition = styled.div`
  display: flex;
  align-items: center;
`

export const CartCallout = styled.div`
  text-align: center;
`

export const NavCallout = styled.div`
  text-align: center;
  margin-left: 16px;
  @media only screen and (max-width: ${VIEWPORT.lg}) {
    display: none;
  }
`

export const ButtonPadding = styled.div`
  min-width: 197px;
  div > a > div,
  div > a > div > div {
    padding: 8px 0px !important;
  }
`
